import { InvoiceStatusEnum } from '@fora-monorepo/employer-my-pages-common/types';
import { TagVariant } from '@foradevelopment/fora-ui';

export const getStatusColor = (status: InvoiceStatusEnum): TagVariant => {
  switch (status) {
    case InvoiceStatusEnum.DebtCollection:
    case InvoiceStatusEnum.Reminded:
      return 'error';
    case InvoiceStatusEnum.InstallmentPlan:
    case InvoiceStatusEnum.Disputed:
    case InvoiceStatusEnum.PaymentDeferral:
      return 'informational';
    case InvoiceStatusEnum.Paid:
      return 'success';
    default:
      return 'additionalGray';
  }
};
